import {useLayoutEffect, useState} from 'react';

import type {Signal} from '@pexip/signal';

export const getShouldRenderUserNamePageHook =
    (renderUserNamePageSignal: Signal<boolean>) => () => {
        const [shouldRenderUserNamePage, setShouldRenderUserNamePage] =
            useState(true);

        useLayoutEffect(() => {
            renderUserNamePageSignal.add(shouldRender => {
                setShouldRenderUserNamePage(shouldRender);
            });
        }, [renderUserNamePageSignal]);

        return shouldRenderUserNamePage;
    };
